import { officeApi } from '@atheneum/api'
import { extendObservable, computed, action } from 'mobx'

class OfficeStore {
  constructor(growlStore) {
    extendObservable(this, {
      id: null,
      office: null,
      loading: false,
      anonymizeClientsLoading: false,
      error: null,
      projectCount: null,
      projectFeedback: null,
      projectFeedbackAvg: computed(() => {
        if (this.projectFeedback) {
          return this.projectFeedback.toFixed(2)
        } else {
          return 'N/A'
        }
      }),
      growlStore
    })
  }

  load(id) {
    this.id = Number(id)
    this.loading = true

    return officeApi
      .getOffice(id)
      .then(office => {
        this.office = office

        Promise.all([
          officeApi.getProjectCount(id),
          officeApi.getFeedbacks(id)
        ]).then(([projectCount, projectFeedback]) => {
          this.projectCount = projectCount
          this.projectFeedback = projectFeedback.ratingAvg

          this.loading = false
        })
      })
      .catch(err => {
        this.error = err
        this.loading = false
      })
  }

  deleteOffice = action(officeId => {
    return officeApi.deleteOffice(officeId).catch(err => {
      this.error = err
      this.growlStore.showError(err)

      throw err
    })
  })
}

export default OfficeStore
